var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repairService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var KosekiRemarkService = /** @class */ (function () {
    function KosekiRemarkService() {
    }
    /**
     * 户籍备注查询
     */
    KosekiRemarkService.prototype.search = function (data, page, sort, loading) {
        return this.netService.send({
            server: repairService.kosekiRemarkController.search,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 户籍备注创建
     */
    KosekiRemarkService.prototype.insert = function (data, loading) {
        return this.netService.send({
            server: repairService.kosekiRemarkController.insert,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除户籍备注
     */
    KosekiRemarkService.prototype.delete = function (data, loading) {
        return this.netService.send({
            server: repairService.kosekiRemarkController.delete,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改户籍备注
     */
    KosekiRemarkService.prototype.update = function (data, loading) {
        return this.netService.send({
            server: repairService.kosekiRemarkController.update,
            data: data,
            loading: loading
        });
    };
    /**
     * 按导入批次删除户籍资料
     */
    KosekiRemarkService.prototype.deleteByBatch = function (batchNumber, loading) {
        return this.netService.send({
            server: repairService.kosekiRemarkController.deleteByBatch,
            data: {
                batchNumber: batchNumber
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], KosekiRemarkService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], KosekiRemarkService.prototype, "search", null);
    return KosekiRemarkService;
}());
export { KosekiRemarkService };
